import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { ApiService } from 'src/app/core/services/api.service';
import { GetBrandBriefResponse, GetBrandListResponse, GetBrandNamesFromBrandIdsParams, GetBrandNamesFromBrandIdsResponse } from '../dtos';

@Injectable({
  providedIn: 'root',
})
export class BrandsService {
  constructor(private readonly apiService: ApiService) {}

  /**
   * Get brand brief, which return a detailed brand object
   * @param brandUuid
   */
  getBrandBrief(brandUuid: string): Observable<GetBrandBriefResponse> {
    return this.apiService.get(`/v2/brands/${brandUuid}/brief`);
  }

  /**
   * Get list of brands
   */
  getBrandList(): Observable<GetBrandListResponse> {
    return this.apiService.get('/v1/brands/list');
  }

  /**
   * Get Brand names from Brand ids
   * permissions: {mode: "+r", res: "brand.displayName"}
   * @param getBrandNamesFromBrandIdsParams
   */
  getBrandNamesFromBrandIds(
    getBrandNamesFromBrandIdsParams: GetBrandNamesFromBrandIdsParams
  ): Observable<GetBrandNamesFromBrandIdsResponse> {
    return this.apiService.post(
      '/v2-internal/brands/name/search',
      getBrandNamesFromBrandIdsParams
    );
  }
}
